<template>
    <form
        class="form basic-form trip-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <div v-if="!!successMessage" class="form-message">
            {{ successMessage }}
        </div>
        <!-- email -->
        <div class="form-field">
            <label for="email">Email:</label>
            <input
                id="email"
                v-model="form.email.value"
                type="email"
                autocomplete="email"
            />
            <FormError :errors="errors.email" />
        </div>

        <div class="form-field">
            <label for="password">Password:</label>
            <input
                id="password"
                v-model="form.password.value"
                type="password"
                autocomplete="current-password"
            />
            <FormError :errors="errors.password" />
        </div>
        <div class="form-buttons vertical">
            <Bttn id="submit-login" type="submit">Save</Bttn>
        </div>
        <div class="forgot-password">
            <router-link to="/forgot-password">Forgot password?</router-link>
        </div>
        <div class="form-buttons vertical">
            <hr />
            <GoogleButton @click="googleLogin">
                Login with Google
            </GoogleButton>
        </div>
        <p class="form-notice">
            Signing in with Google for the first time creates an account. Our
            <router-link to="/privacy">privacy policy</router-link> applies.
        </p>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import FormError from "js/components/forms/FormError";
import GoogleButton from "js/components/custom/GoogleButton";

export default {
    name: "LoginForm",
    components: {
        FormError,
        GoogleButton,
    },
    extends: BaseForm,
    data() {
        return {
            form: {
                email: {
                    value: "",
                },
                password: {
                    value: null,
                },
            },
        };
    },
    methods: {
        googleLogin(event) {
            event.preventDefault();
            window.location.href = "/google-auth/redirect";
        },
    },
};
</script>
